import { render, staticRenderFns } from "./borderType.vue?vue&type=template&id=ff400c36&scoped=true&"
import script from "./borderType.vue?vue&type=script&lang=js&"
export * from "./borderType.vue?vue&type=script&lang=js&"
import style0 from "./borderType.vue?vue&type=style&index=0&id=ff400c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff400c36",
  null
  
)

export default component.exports